import { OrganizationModel } from '../../../modules/organization/model/organization.model';
import { Templates } from './templates';
import { IRenderer } from '../renderer';

export class OrganizationRenderer implements IRenderer {
  RenderHeader(preview: any) {
    if (preview as OrganizationModel) {
      const organization = preview as OrganizationModel;
      return '<b>' + organization.mekhCode + '</b>';
    }

    return '<b>invalid databinding</b>';
  }

  RenderBody(preview: any) {
    let html = '<ul class="bulletless">';
    if (preview as OrganizationModel) {
      const organization = preview as OrganizationModel;
      if (organization.name) { html += Templates.listItem('Megnevezés:', organization.name); }
      if (organization.address) { html += Templates.listItem('Cím:', organization.address); }
      if (organization.site) { html += Templates.listItem('Telephely infó:', organization.site); }
      if (organization.license) { html += Templates.listItem('Engedély infó:', organization.license); }
      if (organization.owner) { html += Templates.listItem('Tulajdonosi infó:', organization.owner); }
    }
    html += '</ul>';
    return html;
  }
}




// WEBPACK FOOTER //
// ./src/app/common/preview.service/renderers/organization.renderer.ts